var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.153 15.103H16.07l-.385-.37a8.85 8.85 0 0 0 2.154-5.794c0-4.917-3.993-8.903-8.92-8.903C3.993.036 0 4.022 0 8.939s3.993 8.904 8.919 8.904a8.889 8.889 0 0 0 5.805-2.151l.371.384v1.081l6.861 6.835L24 21.951l-6.847-6.848Zm-8.234 0a6.162 6.162 0 0 1-6.175-6.164 6.161 6.161 0 0 1 6.175-6.163 6.162 6.162 0 0 1 6.176 6.163 6.162 6.162 0 0 1-6.176 6.164Z"
  })));
};
export default SvgSearch;